import styled, { css } from "styled-components";

export const Modal = styled.div`
  background-color: rgba(0 , 0, 0, .6);
  backdrop-filter: blur(2px);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
  &.modal {
    background-color: transparent;
  }
`;

export const ModalContent = styled.div`
  background-color: ${({theme}) => theme.colors.basic};
  border-radius: ${({theme}) => theme.radius.max};
  box-shadow: 0 4px 12px 0 ${({theme}) => theme.colors.default};
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  width: 700px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    border-radius: ${({theme}) => theme.radius.round};
    width: 620px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 500px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border-radius: ${({theme}) => theme.radius.medium};
    width: 420px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 400px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-radius: ${({theme}) => theme.radius.round};
    width: 320px;
  }
`;

export const ModalHeading = styled.div`
  padding: 70px 72px;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 56px 62px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 44px 56px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 40px 48px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 36px 42px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 40px 30px;
  }
  ${prop => prop.heading && css`
    padding-bottom: 50px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      padding-bottom: 44px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      padding-bottom: 36px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      padding-bottom: 30px;
    }
  `}
`;

export const ModalTitle = styled.h3`
  width: 480px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 400px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 310px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 250px;
  }
`;

export const CloseBtn = styled.button`
  opacity: .7;
  position: absolute;
  right: 16px;
  top: 16px;
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    right: 12px;
    top: 12px;
  }
  &:hover {
    opacity: 1;
  }
  svg {
    font-size: ${({theme}) => theme.fonts.subTitle};
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.hdSubTitle};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
    }
  }
`;

export const ModalBody = styled.div`
  padding: 0 72px 70px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 0 62px 56px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 0 56px 48px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 0 48px 42px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 0 42px 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 0 30px 40px;
  }
`;

export const Form = styled.form``;

export const FormField = styled.div`
  margin-bottom: 60px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-bottom: 50px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-bottom: 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-bottom: 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-bottom: 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-bottom: 40px;
  }
  .selectField {
    div {
      font-family: 'RubikRegular';  
    }
    .css-1fdsijx-ValueContainer {
      padding-left: 0;
    }
    .css-13cymwt-control {
      border: none;
      border-bottom: 1px solid ${({theme}) => theme.colors.border};
      border-radius: 0;
    }
    .css-t3ipsp-control {
      border: none;
      box-shadow: none;
      border-radius: 0;
      border-bottom: 1px solid ${({theme}) => theme.colors.secondary};
    }
  }
`;

export const InputField = styled.input`
  border: none;
  border-bottom: 1px solid ${({theme}) => theme.colors.border};
  font-family: "RubikRegular";
  outline: none;
  padding: 4px 0;
  transition: all .3s ease-in-out;
  width: 100%;
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 2px 0;
  }
  &:focus {
    border-bottom: 1px solid ${({theme}) => theme.colors.secondary};
  }
  &::placeholder {
    color: ${({theme}) => theme.colors.default};
  }
`;

export const SelectField = styled.select`
  border: none;
  border-bottom: 1px solid ${({theme}) => theme.colors.border};
  font-family: "RubikRegular";
  outline: none;
  padding: 4px 0;
  transition: all .3s ease-in-out;
  width: 100%;
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 2px 0;
  }
  &:focus {
    border-bottom: 1px solid ${({theme}) => theme.colors.secondary};
  }
  &::placeholder {
    color: ${({theme}) => theme.colors.default};
  }
`;

export const Option = styled.option``;

export const ButtonWrapper = styled.div`
  margin-top: -16px;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: -12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-top: -8px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 0;
  }
`;

export const SubmitButton = styled.button`
  background-color: ${({theme}) => theme.colors.secondary};
  box-shadow: 2px 4px 15px 0 ${({theme}) => theme.colors.secondary};
  color: ${({theme}) => theme.colors.basic};
  font-family: "RubikRegular";
  padding: 18px 40px;
  width: 100%;
  &:hover {
    box-shadow: none;
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 16px 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    box-shadow: 0 2px 10px 0 ${({theme}) => theme.colors.secondary};
    padding: 12px 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 10px 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    box-shadow: 0 2px 8px 0 ${({theme}) => theme.colors.secondary};
    padding: 8px 10px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    box-shadow: 0 3px 6px 0 ${({theme}) => theme.colors.secondary};
    padding: 12px 10px;
  }
`;

export const StyledLoginButton = styled.button`
  align-items: center;
  border: 1px solid ${({theme}) => theme.colors.default};
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 24px;
  padding: 20px;
  width: 100%;
  &:hover {
    background-color: ${({theme}) => theme.colors.light};
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    gap: 10px;
    margin-bottom: 16px;
    padding: 10px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 16px;
  }
`;

export const Image = styled.img`
  width: 25px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 21px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 18px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 14px;
  }
`;

export const Span = styled.span``;
